"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { classNames, Flex, FlexColumn, Media, QuantityInput, Separator, SpaceBetween, TextBody } from "@opensea/ui-kit";
import { Delete } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { useShallow } from "zustand/react/shallow";
import { MAX_MINTABLE_MAX } from "@/components/collection/drops/constants";
import { TokenPrice, TokenPriceDisplay } from "@/components/price/TokenPrice";
import { UsdPriceDisplay } from "@/components/price/UsdPrice";
import { useIs1155WithTokenWaves } from "@/hooks/use-flags";
import { useDropStore } from "../CollectionDropContext";
import { MintButton } from "../MintButton";
export function MintOptionsPicker() {
  const $ = _c(64);
  const t = useTranslations("MintOptionsPicker");
  const {
    formState: t0,
    register,
    setValue,
    trigger,
    control
  } = useFormContext();
  const {
    errors
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "selectedTokenOptions"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fields: selectedOptionsFields,
    append,
    remove
  } = useFieldArray(t1);
  let t2;
  if ($[2] !== control) {
    t2 = {
      control,
      name: "selectedTokenOptions"
    };
    $[2] = control;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedOptions = useWatch(t2);
  const [totalSupplyPerToken, maxSupplyPerToken, tokenOptions, currentStage, collectionSlug, getTokenEligiblePrice, getTokenMaxMints] = useDropStore(useShallow(_temp));
  const is1155WithTokenWaves = useIs1155WithTokenWaves(collectionSlug);
  let t3;
  if ($[4] !== append || $[5] !== remove || $[6] !== selectedOptions) {
    t3 = tokenId => {
      const existingIndex = selectedOptions?.findIndex(field => field.tokenId === String(tokenId));
      if (existingIndex !== undefined && existingIndex !== -1) {
        remove(existingIndex);
      } else {
        append({
          tokenId: String(tokenId),
          quantity: 1
        });
      }
    };
    $[4] = append;
    $[5] = remove;
    $[6] = selectedOptions;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleOptionSelect = t3;
  let t4;
  if ($[8] !== remove) {
    t4 = fieldIndex => {
      if (fieldIndex !== -1) {
        remove(fieldIndex);
      }
    };
    $[8] = remove;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleOptionRemove = t4;
  let t5;
  if ($[10] !== setValue || $[11] !== trigger) {
    t5 = async (fieldIndex_0, quantity) => {
      if (fieldIndex_0 !== null) {
        setValue(`selectedTokenOptions.${fieldIndex_0}.quantity`, quantity);
        await trigger(`selectedTokenOptions.${fieldIndex_0}.quantity`);
      }
    };
    $[10] = setValue;
    $[11] = trigger;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleQuantityUpdate = t5;
  let T0;
  let t6;
  let t7;
  if ($[13] !== currentStage?.maxTotalMintableByWallet || $[14] !== currentStage?.tokenDetailsMap || $[15] !== errors || $[16] !== getTokenEligiblePrice || $[17] !== getTokenMaxMints || $[18] !== handleOptionRemove || $[19] !== handleOptionSelect || $[20] !== handleQuantityUpdate || $[21] !== is1155WithTokenWaves || $[22] !== maxSupplyPerToken || $[23] !== register || $[24] !== selectedOptions || $[25] !== selectedOptionsFields || $[26] !== t || $[27] !== tokenOptions || $[28] !== totalSupplyPerToken) {
    let t8;
    if ($[32] !== tokenOptions) {
      t8 = tokenOptions ?? {};
      $[32] = tokenOptions;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    const flattenedOptions = Object.values(t8).flat();
    let t9;
    if ($[34] !== currentStage?.tokenDetailsMap || $[35] !== getTokenEligiblePrice || $[36] !== selectedOptions) {
      t9 = selectedOptions ? selectedOptions.reduce((acc, val) => {
        const eligiblePrice = getTokenEligiblePrice(val.tokenId);
        const fallbackPrice = currentStage?.tokenDetailsMap?.[val.tokenId]?.price;
        const price = eligiblePrice ?? fallbackPrice;
        const token = price?.token.unit ?? 0;
        const usd = price?.usd ?? 0;
        return {
          token: acc.token + token * (val.quantity ?? 1),
          usd: acc.usd + usd * (val.quantity ?? 1)
        };
      }, {
        token: 0,
        usd: 0
      }) : null;
      $[34] = currentStage?.tokenDetailsMap;
      $[35] = getTokenEligiblePrice;
      $[36] = selectedOptions;
      $[37] = t9;
    } else {
      t9 = $[37];
    }
    const totalPrice = t9;
    const firstSelectedTokenId = selectedOptions?.[0]?.tokenId;
    let t10;
    if ($[38] !== firstSelectedTokenId || $[39] !== getTokenEligiblePrice) {
      t10 = firstSelectedTokenId ? getTokenEligiblePrice(firstSelectedTokenId) : null;
      $[38] = firstSelectedTokenId;
      $[39] = getTokenEligiblePrice;
      $[40] = t10;
    } else {
      t10 = $[40];
    }
    const firstTokenEligiblePrice = t10;
    const firstTokenPrice = firstTokenEligiblePrice ?? (firstSelectedTokenId ? currentStage?.tokenDetailsMap?.[firstSelectedTokenId]?.price : null);
    const optionChain = firstTokenPrice?.token.chain.identifier ?? "";
    const optionContractAddress = firstTokenPrice?.token.contractAddress ?? "";
    const optionSymbol = firstTokenPrice?.token.symbol;
    let t11;
    if ($[41] !== tokenOptions) {
      t11 = Object.values(tokenOptions ?? {}).reduce(_temp2, 0);
      $[41] = tokenOptions;
      $[42] = t11;
    } else {
      t11 = $[42];
    }
    const totalOptions = t11;
    T0 = FlexColumn;
    let t12;
    if ($[43] !== tokenOptions) {
      t12 = Object.keys(tokenOptions ?? {});
      $[43] = tokenOptions;
      $[44] = t12;
    } else {
      t12 = $[44];
    }
    if ($[45] !== currentStage?.maxTotalMintableByWallet || $[46] !== getTokenMaxMints || $[47] !== handleOptionSelect || $[48] !== is1155WithTokenWaves || $[49] !== maxSupplyPerToken || $[50] !== selectedOptionsFields || $[51] !== t12 || $[52] !== tokenOptions || $[53] !== totalOptions || $[54] !== totalSupplyPerToken) {
      t6 = <Flex className="my-6 grid grid-cols-4 gap-3 md:grid-cols-4">{t12.map(tokenOptionGroup => {
          const options_0 = tokenOptions?.[tokenOptionGroup] ?? [];
          return [...options_0].sort((a, b) => is1155WithTokenWaves ? b.tokenId - a.tokenId : a.tokenId - b.tokenId).map(option => {
            const totalSupply = totalSupplyPerToken?.[option.tokenId] ?? 0;
            const maxSupply = maxSupplyPerToken?.[option.tokenId] ?? 0;
            const isSelected = selectedOptionsFields.some(selectedOption => selectedOption.tokenId === String(option.tokenId));
            return <Button className={classNames("col-span-2 whitespace-normal", totalOptions === 1 ? "md:col-span-4" : totalOptions === 2 ? "md:col-span-2" : totalOptions === 3 ? "md:col-span-1" : "md:col-span-1", isSelected ? "shadow-[0_0_0_2px_white]" : "")} disabled={(getTokenMaxMints(String(option.tokenId)) ?? currentStage?.maxTotalMintableByWallet ?? 0) <= 0 || totalSupply >= maxSupply} key={option.tokenId} onClick={() => handleOptionSelect(option.tokenId)} variant="tertiary">{option.groupValue}</Button>;
          });
        })}</Flex>;
      $[45] = currentStage?.maxTotalMintableByWallet;
      $[46] = getTokenMaxMints;
      $[47] = handleOptionSelect;
      $[48] = is1155WithTokenWaves;
      $[49] = maxSupplyPerToken;
      $[50] = selectedOptionsFields;
      $[51] = t12;
      $[52] = tokenOptions;
      $[53] = totalOptions;
      $[54] = totalSupplyPerToken;
      $[55] = t6;
    } else {
      t6 = $[55];
    }
    t7 = selectedOptions?.length ? <><FlexColumn className="gap-4 md:gap-3">{selectedOptionsFields.map((t13, index) => {
          const {
            tokenId: tokenId_0
          } = t13;
          const option_0 = flattenedOptions.find(o => o.tokenId === Number(tokenId_0));
          const maxMints = getTokenMaxMints(tokenId_0) ?? currentStage?.tokenDetailsMap?.[tokenId_0]?.maxTotalMintableByWallet ?? 0;
          const quantity_0 = selectedOptions[index]?.quantity ?? 1;
          if (!option_0) {
            return null;
          }
          const eligiblePrice_0 = getTokenEligiblePrice(tokenId_0);
          const price_0 = eligiblePrice_0 ?? currentStage?.tokenDetailsMap?.[tokenId_0]?.price;
          return <FlexColumn className="items-end gap-2" key={tokenId_0}><SpaceBetween className="w-full items-center"><FlexColumn className="gap-1"><TextBody weight="semibold">{option_0.groupValue}</TextBody>{maxMints !== MAX_MINTABLE_MAX ? <Media greaterThanOrEqual="md"><TextBody className="font-mono uppercase" color="text-tertiary" size="xs">{t("limitPerToken", {
                      max: maxMints
                    })}</TextBody></Media> : null}</FlexColumn><Flex className="items-center gap-2 md:gap-3"><TokenPrice multiplier={quantity_0} price={price_0} /><QuantityInput {...register(`selectedTokenOptions.${index}.quantity`, {
                  valueAsNumber: true,
                  validate: {
                    isBetweenOneAndMax: v => !Number.isNaN(v) && v !== null && v >= 1 && v <= maxMints || `Quantity must be between 1 and ${String(maxMints)}`
                  }
                })} className="w-24" error={Boolean(errors.selectedTokenOptions?.[index]?.quantity)} max={maxMints} min={1} onValueChange={value => handleQuantityUpdate(index, value)} value={quantity_0} /><Button icon={Delete} onClick={() => handleOptionRemove(index)} size="sm" variant="ghost" /></Flex></SpaceBetween>{maxMints !== MAX_MINTABLE_MAX ? <Media lessThan="md"><TextBody className="font-mono uppercase" color="text-tertiary" size="xs">{t("limitPerToken", {
                  max: maxMints
                })}</TextBody></Media> : null}</FlexColumn>;
        })}</FlexColumn><Separator className="my-3" />{totalPrice ? <SpaceBetween className="pb-3"><TextBody weight="semibold">{t("total")}</TextBody><Flex className="gap-1.5">{optionChain && optionContractAddress ? <TextBody color="text-secondary">{t.rich("usdPrice", {
              usdPrice: () => <UsdPriceDisplay currency={{
                chainIdentifier: optionChain,
                contractAddress: optionContractAddress
              }} unitPrice={totalPrice.token} usdPrice={totalPrice.usd} />
            })}</TextBody> : null}<TextBody weight="semibold"><TokenPriceDisplay chain={optionChain} contractAddress={optionContractAddress} symbol={optionSymbol} unit={totalPrice.token} usdPrice={totalPrice.usd} /></TextBody></Flex></SpaceBetween> : null}</> : null;
    $[13] = currentStage?.maxTotalMintableByWallet;
    $[14] = currentStage?.tokenDetailsMap;
    $[15] = errors;
    $[16] = getTokenEligiblePrice;
    $[17] = getTokenMaxMints;
    $[18] = handleOptionRemove;
    $[19] = handleOptionSelect;
    $[20] = handleQuantityUpdate;
    $[21] = is1155WithTokenWaves;
    $[22] = maxSupplyPerToken;
    $[23] = register;
    $[24] = selectedOptions;
    $[25] = selectedOptionsFields;
    $[26] = t;
    $[27] = tokenOptions;
    $[28] = totalSupplyPerToken;
    $[29] = T0;
    $[30] = t6;
    $[31] = t7;
  } else {
    T0 = $[29];
    t6 = $[30];
    t7 = $[31];
  }
  let t8;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      Button: {
        className: "w-full"
      }
    };
    $[56] = t8;
  } else {
    t8 = $[56];
  }
  let t9;
  if ($[57] !== collectionSlug) {
    t9 = <MintButton className="w-full" collectionSlug={collectionSlug} overrides={t8} showQtyInput={false} size="lg" />;
    $[57] = collectionSlug;
    $[58] = t9;
  } else {
    t9 = $[58];
  }
  let t10;
  if ($[59] !== T0 || $[60] !== t6 || $[61] !== t7 || $[62] !== t9) {
    t10 = <T0>{t6}{t7}{t9}</T0>;
    $[59] = T0;
    $[60] = t6;
    $[61] = t7;
    $[62] = t9;
    $[63] = t10;
  } else {
    t10 = $[63];
  }
  return t10;
}
function _temp2(count, options) {
  return count + (options?.length ?? 0);
}
function _temp(state) {
  const current = state.stages.find(stage => stage.stageIndex === state.activeStageIndex) ?? null;
  return [state.totalSupplyPerToken, state.maxSupplyPerToken, state.tokenOptions, current, state.collectionSlug, state.getTokenEligiblePrice, state.getTokenMaxMints];
}